import naja from 'naja';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import { cs } from 'date-fns/locale';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.cs.min.js';

if (!naja) {
    naja = require('naja');
    naja.initialize();
    console.log('Naja initialized successfully');
} else {
    console.log('Naja is OK');
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('Document loaded chart...');

    const Graph = new DeviceGraph();
    Graph.init();
    naja.addEventListener('complete', () => {
        Graph.init();
    });
});

class DeviceGraph {
    constructor() {
        this.isProcessing = false;
        this.chart = null;

        this.xAxisConfigs = {
            daily: {
                type: 'time',
                time: {
                    unit: 'day',
                    displayFormats: {
                        day: 'dd.MM.yyyy'
                    },
                    locale: cs
                },
                ticks: {
                    source: 'auto',
                    callback: function(value, index, ticks) {
                        const date = new Date(value);
                        return new Intl.DateTimeFormat('cs-CZ', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        }).format(date);
                    }
                },
                title: {
                    display: true,
                    text: 'Datum'
                }
            },
            hourly: {
                type: 'time',
                time: {
                    unit: 'hour',
                    displayFormats: {
                        hour: 'HH:00'
                    },
                    stepSize: 1,
                    locale: cs
                },
                ticks: {
                    source: 'auto',
                    callback: function(value, index, ticks) {
                        const date = new Date(value);
                        if (date.getMinutes() === 0) {
                            return new Intl.DateTimeFormat('cs-CZ', {
                                hour: '2-digit',
                                minute: '2-digit'
                            }).format(date);
                        }
                        return null;
                    }
                },
                title: {
                    display: true,
                    text: 'Čas'
                }
            },
            monthly: {
                type: 'time',
                time: {
                    unit: 'month',
                    displayFormats: {
                        month: 'MMMM'
                    },
                    locale: cs
                },
                ticks: {
                    source: 'auto',
                    callback: function(value, index, ticks) {
                        const date = new Date(value);
                        return new Intl.DateTimeFormat('cs-CZ', {
                            month: 'long'
                        }).format(date);
                    }
                },
                title: {
                    display: true,
                    text: 'Měsíc'
                }
            }
        };
    }

    init() {
        const chartElement = document.getElementById('myChart');
        if (!chartElement) {
            console.log('Canvas element not found...');
            return;
        }

        const dataSource = chartElement.getAttribute('data-source');
        if (!dataSource) {
            console.error('Data source not specified');
            return;
        }

        this.initDatePicker();
        this.initMonthYearPicker();

        const datePicker = document.getElementById('datePicker');
        const defaultDate = datePicker ? datePicker.value : new Date().toLocaleDateString('cs-CZ', { day: '2-digit', month: '2-digit', year: 'numeric' });
        this.loadChartDataByDate(defaultDate);
    }

    initDatePicker() {
        const datePicker = document.getElementById('datePicker');
        if (datePicker) {
            const $datePicker = $(datePicker);
            $datePicker.datepicker({
                format: 'dd.mm.yyyy',
                autoclose: true,
                todayHighlight: true,
                language: 'cs'
            });
            $('[data-toggle="datepicker"]').on('click', () => {
                $datePicker.datepicker('show');
            });
            $datePicker.on('changeDate', (e) => {
                const selectedDate = $(datePicker).val();
                console.log('Selected date:', selectedDate);
                // Reset month and year pickers
                const monthPicker = document.getElementById('monthPicker');
                const yearPicker = document.getElementById('yearPicker');
                if (monthPicker) monthPicker.value = '0';
                if (yearPicker) yearPicker.value = '0';
                this.loadChartDataByDate(selectedDate, 'hourly');
            });
        } else {
            console.error('Datepicker element not found');
        }
    }

    initMonthYearPicker() {
        const monthPicker = document.getElementById('monthPicker');
        const yearPicker = document.getElementById('yearPicker');
        if (!monthPicker || !yearPicker) {
            console.error('Month or year picker element not found');
            return;
        }

        monthPicker.addEventListener('change', () => {
            const selectedMonth = parseInt(monthPicker.value);
            if (selectedMonth >= 1 && selectedMonth <= 12) {
                const selectedYear = parseInt(yearPicker.value) || new Date().getFullYear(); // Aktuální rok, pokud není vybrán
                const dateFrom = `01.${selectedMonth.toString().padStart(2, '0')}.${selectedYear}`;
                const lastDay = new Date(selectedYear, selectedMonth, 0).getDate();
                const dateTo = `${lastDay}.${selectedMonth.toString().padStart(2, '0')}.${selectedYear}`;
                console.log('Selected month:', selectedMonth, 'year:', selectedYear, 'Range:', dateFrom, 'to', dateTo);
                // Reset date picker
                const datePicker = document.getElementById('datePicker');
                if (datePicker) datePicker.value = '';
                this.loadChartDataByDate(null, dateFrom, dateTo, 'daily');
            }
        });

        yearPicker.addEventListener('change', () => {
            const selectedYear = parseInt(yearPicker.value);
            if (selectedYear >= 2024 && selectedYear <= 2026) {
                // Reset month picker
                monthPicker.value = '0';
                const dateFrom = `01.01.${selectedYear}`;
                const dateTo = `31.12.${selectedYear}`;
                console.log('Selected year:', selectedYear, 'Range:', dateFrom, 'to', dateTo);
                // Reset date picker
                const datePicker = document.getElementById('datePicker');
                if (datePicker) datePicker.value = '';
                this.loadChartDataByDate(null, dateFrom, dateTo, 'monthly');
            }
        });
    }

    loadChartDataByDate(date, dateFrom = null, dateTo = null, typ = 'hourly') {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;
        const chartElement = document.getElementById('myChart');
        if (!chartElement) {
            console.error('Chart element not found');
            this.isProcessing = false;
            return;
        }

        const baseUrl = chartElement.getAttribute('data-source');
        let url = baseUrl;
        if (date) {
            const separator = baseUrl.includes('?') ? '&' : '?';
            url = `${baseUrl}${separator}date=${encodeURIComponent(date)}`;
        } else if (dateFrom && dateTo) {
            const separator = baseUrl.includes('?') ? '&' : '?';
            url = `${baseUrl}${separator}dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`;
        }

        console.log('Loading chart data from:', url);

        fetch(url, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            signal: AbortSignal.timeout(50000) // Timeout nastaven na 50 000 ms
        })
            .then(async response => {
                if (!response.ok) {
                    const text = await response.text();
                    console.error('GET response error:', { status: response.status, body: text });
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                console.log('Chart data loaded:', data);
                this.renderChart(data, typ);

                if (naja && typeof naja.makeRequest === 'function') {
                    console.log('Attempting to refresh gridGraph snippet with date:', date || `${dateFrom} to ${dateTo}`);
                    return naja.makeRequest('POST', baseUrl, { selectedDate: date, dateFrom, dateTo }, {
                        history: false
                    }).then(response => {
                        console.log('Grid snippet refreshed:', date || `${dateFrom} to ${dateTo}`);
                        console.log('Naja response:', response);
                        if (response.snippets && response.snippets['snippet--gridGraph']) {
                            //console.log('Snippet content:', response.snippets['snippet--gridGraph']);
                            const gridContainer = document.querySelector('#gridGraphContainer');
                            if (gridContainer) {
                                console.log('Grid container found, updating content');
                                gridContainer.innerHTML = response.snippets['snippet--gridGraph'];
                            } else {
                                console.error('Grid container #gridGraphContainer not found');
                            }
                        } else {
                            console.error('No snippet--gridGraph in response');
                        }
                    }).catch(async error => {
                        console.error('Error refreshing grid snippet via Naja:', error);
                        try {
                            const response = await fetch(baseUrl, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    'X-Requested-With': 'XMLHttpRequest'
                                },
                                body: date ? `selectedDate=${encodeURIComponent(date)}` : `dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`,
                                signal: AbortSignal.timeout(50000) // Timeout nastaven na 50 000 ms
                            });
                            const text = await response.text();
                            console.error('POST response error:', { status: response.status, body: text });
                        } catch (e) {
                            console.error('Failed to fetch POST response for debug:', e);
                        }
                    });
                } else {
                    console.warn('Naja is not available, cannot refresh grid');
                }
            })
            .catch(error => {
                console.error('Error in loadChartDataByDate:', error);
            })
            .finally(() => {
                this.isProcessing = false;
            });
    }

    renderChart(data, typ) {
        const ctx = document.getElementById('myChart').getContext('2d');
        if (!ctx) {
            console.error('Canvas context not found');
            return;
        }

        if (this.chart) {
            this.chart.destroy();
        }

        const chartElement = document.getElementById('myChart');
        const yUnit = chartElement.getAttribute('data-y-unit') || 'W';

        this.chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: data.labels,
                datasets: [
                    {
                        label: 'Přetok',
                        data: data.values,
                        borderColor: function(context) {
                            // Získá hodnotu z datového bodu
                            const value = context.dataset.data[context.dataIndex];
                            // Zelená pro kladné hodnoty, červená pro záporné
                            return value >= 0 ? '#18920bff' : '#dc3545';
                        },
                        backgroundColor: function(context) {
                            const value = context.dataset.data[context.dataIndex];
                            // Odpovídající transparentní pozadí pro oblasti
                            return value >= 0 ? 'rgba(24, 146, 11, 0.1)' : 'rgba(220, 53, 69, 0.1)';
                        },
                        pointBackgroundColor: function(context) {
                            const value = context.dataset.data[context.dataIndex];
                            return value >= 0 ? '#18920bff' : '#dc3545';
                        },
                        segment: {
                            borderColor: function(context) {
                                // Pro segment čáry - určuje barvu čáry mezi body
                                // Kontroluje, zda jsou oba body na stejné straně od nuly
                                const prev = context.p0.parsed.y;
                                const curr = context.p1.parsed.y;

                                // Pokud jsou obě hodnoty kladné, zelená čára
                                if (prev >= 0 && curr >= 0) return '#18920bff';
                                // Pokud jsou obě hodnoty záporné, červená čára
                                if (prev < 0 && curr < 0) return '#dc3545';
                                // Pokud přechází nulou, použij gradient
                                return context.p0.parsed.y < context.p1.parsed.y ?
                                    ['#dc3545', '#18920bff'] : ['#18920bff', '#dc3545'];
                            }
                        },
                        fill: false,
                        tension: 0.4,
                        pointRadius: 5,
                        pointBorderWidth: 1,
                        pointBorderColor: '#fff'
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: this.xAxisConfigs[typ] || this.xAxisConfigs.hourly,
                    y: {
                        title: {
                            display: true,
                            text: 'Hodnota (' + yUnit + ')'
                        },
                        beginAtZero: true,
                        grid: {
                            color: function(context) {
                                // Zvýrazní nulovou linii
                                if (context.tick.value === 0) {
                                    return 'rgba(0, 0, 0, 0.5)';
                                }
                                return 'rgba(0, 0, 0, 0.1)';
                            },
                            lineWidth: function(context) {
                                // Silnější nulová linie
                                if (context.tick.value === 0) {
                                    return 2;
                                }
                                return 1;
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            generateLabels: function(chart) {
                                // Vlastní legendy pro kladné a záporné hodnoty
                                return [
                                    {
                                        text: 'Přetok',
                                        fillStyle: '#18920bff',
                                        strokeStyle: '#18920bff',
                                        pointStyle: 'circle'
                                    },
                                    {
                                        text: 'Odběr ze sítě',
                                        fillStyle: '#dc3545',
                                        strokeStyle: '#dc3545',
                                        pointStyle: 'circle'
                                    }
                                ];
                            }
                        }
                    }
                }
            }
        });
        console.log('Chart instance created with color segments');
    }
}
